export default __webpack_public_path__ + "static/media/top2-medal-icon.54b8a9fa.svg";